/* NEW: UI_REVAMP */
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

const FilterChip = ({ label, background, color, onClear }) => {
	return (
		<Flex
			alignItems='center'
			gap='8px'
			height='24px'
			padding='4px 8px'
			borderRadius='4px'
			background={background}
			color={color}
		>
			<Text fontSize='14px' fontWeight='400' whiteSpace='nowrap' lineHeight='100%'>
				{label}
			</Text>
			{onClear ? (
				<Box
					as='button'
					type='button'
					aria-label={`Clear ${label} filter`}
					width='16px'
					height='16px'
					fontSize='18px'
					lineHeight='16px'
					color={color}
					onClick={onClear}
				>
					×
				</Box>
			) : null}
		</Flex>
	);
};

const AppliedFilterChips = ({ chips = [], ...props }) => {
	const visibleChips = chips.filter(Boolean);

	if (visibleChips.length === 0) return null;

	return (
		<Flex flexWrap='wrap' gap='8px' marginTop='-4px' marginBottom='12px' {...props}>
			{visibleChips.map((chip) => (
				<FilterChip
					key={chip.key || chip.label}
					label={chip.label}
					background={chip.background}
					color={chip.color}
					onClear={chip.onClear}
				/>
			))}
		</Flex>
	);
};

export default AppliedFilterChips;
